export default __webpack_public_path__ + "static/media/kp.5d243e48.svg";